import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import { parseStep } from '../../../features/C3/logic';
import { Wizard } from '../../../features/C3/Wizard';

const searchSchema = z.object({
  clientId: z
    .string()
    .regex(/^[A-Za-z0-9_-]{1,64}$/)
    .optional()
    .catch(undefined),
});

/** /clients/new/<1..7>[?clientId=] — new-client wizard (lane C3, mockups/assets/screens/wizard.js). */
export const Route = createFileRoute('/_app/clients/new/$step')({
  validateSearch: (s: Record<string, unknown>) => searchSchema.parse(s),
  component: NewClientWizard,
});

function NewClientWizard() {
  const { step } = Route.useParams();
  const { clientId } = Route.useSearch();
  const navigate = useNavigate();
  const go = useCallback(
    (n: number, id?: string) => void navigate({ to: '/clients/new/$step', params: { step: String(n) }, search: { clientId: id } }),
    [navigate],
  );
  const done = useCallback((id: string) => void navigate({ to: '/client/$clientId', params: { clientId: id } }), [navigate]);
  return <Wizard key={clientId ?? 'new'} step={parseStep(step)} clientId={clientId} navigate={go} onDone={done} />;
}
